export const palette = {
  primary: {
    main: '#5C67FF',
  },
  secondary: {
    main: '#F7C2FF',
  },
  success: {
    main: '#0AA65B',
  },
  warning: {
    main: '#FFCC00',
  },
  error: {
    main: '#E5452F',
  },
  info: {
    main: '#297EFF',
  },
  common: {
    black: '#000000',
    white: '#ffffff',
  },
  grey: {
    '200': '#eeeeee',
    '300': '#e0e0e0',
    '700': '#616161',
    '800': '#424242',
  },
}

export const paletteDark = {
  background: {
    paper: '#212121',
    default: '#121212',
  },
  text: {
    primary: '#ffffff',
    secondary: '#bbbbbb',
  },
}

export const paletteLight = {
  background: {
    paper: '#ffffff',
    default: '#ffffff',
  },
  text: {
    primary: '#000000',
    secondary: '#747474',
  },
}
